import React from "react";
import { Link } from "react-router-dom";
import { BrandLogo, Button } from "../../ui";

/**
 * Branded 404 (016 §5): real layout + logo + a way back, replacing the bare
 * `<div>404 - Not Found</div>`.
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-6 text-center">
      <BrandLogo className="h-7" />
      <div className="space-y-2">
        <p className="font-title text-5xl font-semibold text-foreground">404</p>
        <p className="text-muted-foreground">
          We couldn&apos;t find the page you were looking for.
        </p>
      </div>
      <Button asChild>
        <Link to="/insights">Back to Insights</Link>
      </Button>
    </div>
  );
}
